import PhotoSwipe from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js';

const leftArrowSVGString = `
<svg xmlns="http://www.w3.org/2000/svg" id="_图层_1" data-name="图层 1" viewBox="0 0 45.2 45.2">
<defs>
  <style>
    .left-cls-1 {
      fill: none;
      stroke: #fff;
      stroke-miterlimit: 10;
      stroke-width: 1.75px;
    }

    .left-cls-2 {
      fill: #0f1822;
      opacity: .15;
    }
  </style>
</defs>
<circle class="left-cls-2" cx="22.6" cy="22.58" r="22.5"/>
<polyline class="left-cls-1" points="27.66 8.94 14.16 22.44 27.66 35.94"/>
</svg>`

const rightArrowSVGString = `
<svg xmlns="http://www.w3.org/2000/svg" id="_图层_1" data-name="图层 1" viewBox="0 0 45.2 45.2">
      <defs>
        <style>
          .right-cls-1 {
            fill: none;
            stroke: #fff;
            stroke-miterlimit: 10;
            stroke-width: 1.75px;
          }

          .right-cls-2 {
            fill: #0f1822;
            opacity: .15;
          }
        </style>
      </defs>
      <circle class="right-cls-2" cx="22.6" cy="22.58" r="22.5"/>
      <polyline class="right-cls-1" points="17.54 8.94 31.04 22.44 17.54 35.94"/>
    </svg>
`
let imageThumList = []
const closeSvgString = `<svg focusable="false" width="20" height="20" class="icon icon--close   " viewBox="0 0 14 14">
<path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.5" fill="none"></path>
</svg>`
let pswpSlider = null
document.addEventListener('DOMContentLoaded', function () {

    // 切换图片
    const goToSlide = (index) => {
        const li = document.querySelectorAll('.pswp__thumbnails li');
        li.forEach(li => {
            li.classList.remove('is-selected');
        });
        li[index].classList.add('is-selected');
        pswpSlider.goTo(index);
    }
    const getWidthHeight = (img) => {
        let width = img.getAttribute('width');
        let height = img.getAttribute('height');
        let maxWidth = window.innerWidth * 0.66;
        if (width > maxWidth) {
            height = maxWidth / (width / height);
            width = maxWidth;
        }
        return { width, height }
    }
    // 初始化轮播
    const initSlider = () => {
        let options = {
            arrowPrevSVG: leftArrowSVGString,
            arrowNextSVG: rightArrowSVGString,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            closeSVG: closeSvgString,
            dataSource: [],
            tapToClose: true,
            showHideAnimationType: 'none',
            padding: { top: 38, bottom: 132 },
            index: 0
        };
        const imgList = document.querySelectorAll('.product__imageViewBox-wrapper img');
        imgList.forEach((img, index) => {
            options.dataSource.push({
                src: img.src,
                ...getWidthHeight(img),
                // width: img.getAttribute('width'),
                // height: img.getAttribute('height'),
                alt: img.alt,
            });
        });
        console.log(options.dataSource);
        imageThumList = options.dataSource;
        pswpSlider = new PhotoSwipe(options);
        // options.index = Number(document.querySelector('.product__media-item.is-selected').dataset.originalPosition);
        bindEvent();
        pswpSlider.init();
        pswpSlider.goTo(Number(document.querySelector('.product__media-item.is-selected').dataset.originalPosition))
    }

    // 绑定事件
    const bindEvent = () => {
        pswpSlider.on('change', function (evt) {
            if (document.querySelector('.pswp__thumbnails li.is-selected')) {
                if (pswpSlider.currIndex === Number(document.querySelector('.pswp__thumbnails li.is-selected').dataset.original)) {
                    return
                } else {
                    goToSlide(pswpSlider.currIndex)
                }
            }
        })
        pswpSlider.on('loadComplete', function (evt) {
            if (document.querySelector('#photoswipe-thumbnails').childNodes.length == 0) {
                let li = '';
                for (let i = 0; i < imageThumList.length; i++) {
                    li += `<li data-original="${i}" class="${i === pswpSlider.currIndex ? 'is-selected' : ''}">
                        <img src="${imageThumList[i].src}" alt="${imageThumList[i].alt}" width="60" height="auto">
                    </li>`;
                }
                let pagination = `
                            <ul class="pswp__thumbnails">
                                ${li}
                            </ul>
                        `;
                document.querySelector('#photoswipe-thumbnails').innerHTML += pagination;
                const paginationUl = document.querySelector('.pswp__thumbnails');
                paginationUl.addEventListener('click', function (event) {
                    if (event.target.tagName === 'IMG') {
                        event.stopPropagation();
                        const index = event.target.parentNode.dataset.original;
                        goToSlide(Number(index))
                    }
                })
            }

        })
        pswpSlider.on('close', function () {
            document.querySelector('#photoswipe-thumbnails').innerHTML = '';
        })

    }
    document.getElementById('magnifyIcon').onclick = () => {
        initSlider();
    }
})